import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const FullPageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-sand" data-testid="page-loader">
    <Loader2 className="h-7 w-7 animate-spin text-emerald-800" />
  </div>
);

export const ProtectedRoute = ({ children, roles, requirePhone = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (requirePhone && !user.phone_verified) return <Navigate to="/verify-phone" replace />;
  if (roles && !roles.includes(user.role))
    return (
      <div className="min-h-screen flex items-center justify-center px-6" data-testid="forbidden-view">
        <div className="max-w-md text-center">
          <h1 className="font-display text-2xl font-bold text-slate-900">Access restricted</h1>
          <p className="mt-3 text-slate-600 text-sm">
            Your role ({user.role.replaceAll("_", " ").toLowerCase()}) cannot open this area. Permissions are enforced on
            the server.
          </p>
        </div>
      </div>
    );
  return children;
};
